// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__BQOMQ","form":"styles_form__1nGUH"};